<template>
  <!-- Advertising contract -->
  <v-select
    :items="advertisingContracts"
    item-text="translatedName"
    item-value="id"
    :menu-props="{bottom: true, offsetY: true}"
    v-model="$store.state.display.elevatorForm.elevator.advertisingContract"
    outlined
    clearable
    :label="$t('display/elevator:edit.labels.data-tab.contract-type')"
  />

</template>

<script>
import EnumUtils from '@/modules/core/services/enum-utils';

export default {
  name: "AdvertisingContract",
  data() {
    return {
      advertisingContracts: []
    }
  },
  methods: {
    loadContracts() {
      EnumUtils.loadEnum('advertisingContract', 'display/elevator', 'advertisingContract',
        (response) => {
          this.advertisingContracts = response;
        }
      );
    }
  },
  created() {
    this.loadContracts();
  }
}
</script>